import { Provider } from '@angular/core';

import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { RoleInterceptor } from './RoleInterceptor';

/** Provider for the role Interceptor. */
export const roleInterceptorProvider: Provider = { provide: HTTP_INTERCEPTORS, useClass: RoleInterceptor, multi: true };
